import { __assign } from "tslib";
import * as React from 'react';
import { StyledIconBase } from '@styled-icons/styled-icon';
export var BellOffOutline = React.forwardRef(function (props, ref) {
  var attrs = {
    "fill": "currentColor",
    "xmlns": "http://www.w3.org/2000/svg"
  };
  return React.createElement(StyledIconBase, __assign({
    iconAttrs: attrs,
    iconVerticalAlign: "middle",
    iconViewBox: "0 0 24 24"
  }, props, {
    ref: ref
  }), React.createElement("g", {
    "data-name": "Layer 2",
    key: "k0"
  }, React.createElement("g", {
    "data-name": "bell-off"
  }, React.createElement("path", {
    d: "M8.9 5.17A4.67 4.67 0 0112.64 4a4.86 4.86 0 014.08 4.9v4.5a1.92 1.92 0 00.1.59l3.6 3.6a1.58 1.58 0 00.45-.6 1.62 1.62 0 00-.35-1.78l-1.8-1.81V8.94a6.86 6.86 0 00-5.82-6.88 6.71 6.71 0 00-5.32 1.61 6.88 6.88 0 00-.58.54l1.47 1.43a4.79 4.79 0 01.43-.47zM14 16.86l-.83-.86H5.51l1.18-1.18a2 2 0 00.59-1.42v-3.29l-2-2a5.68 5.68 0 000 .59v4.7l-1.8 1.81A1.63 1.63 0 004.64 18H8v.34A3.84 3.84 0 0012 22a3.88 3.88 0 004-3.22l-.83-.78zM12 20a1.88 1.88 0 01-2-1.66V18h4v.34A1.88 1.88 0 0112 20zM20.71 19.29L19.41 18l-2-2-9.52-9.53L6.42 5 4.71 3.29a1 1 0 00-1.42 1.42L5.53 7l1.75 1.7 7.31 7.3.07.07L16 17.41l.59.59 2.7 2.71a1 1 0 001.42 0 1 1 0 000-1.42z"
  }))));
});
BellOffOutline.displayName = 'BellOffOutline';
export var BellOffOutlineDimensions = {
  height: 20,
  width: 20
};